import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esNeuropathicPain } from "@/pages/es/esConditionData4";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute(
  "/es/neuropathic-pain-treatment-coral-springs-fl",
)({
  head: () => buildEsConditionHead(esNeuropathicPain),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esNeuropathicPain} />;
}
